var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.365 17.314c.74-1.134 1.135-2.46 1.135-3.814s-.394-2.68-1.135-3.814M21.84 15.356c.427-.524.66-1.18.66-1.856 0-.676-.233-1.332-.66-1.856"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.5 25.5v-18c0-.53.21-1.04.586-1.414C2.46 5.71 2.97 5.5 3.5 5.5h26c.53 0 1.04.21 1.414.586.375.375.586.884.586 1.414v18c0 .53-.21 1.04-.586 1.414-.375.375-.884.586-1.414.586h-26c-.53 0-1.04-.21-1.414-.586C1.71 26.54 1.5 26.03 1.5 25.5zM6.5 22.5h12M22.5 22.5h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.5 10.5h-5v4h5v-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "M19 13.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPay);
export default __webpack_public_path__ + "static/media/card-pay.ca40dff6.svg";
export { ForwardRef as ReactComponent };